import { v4 as uuidv4 } from 'uuid';
import { NativoTout } from '@/app_components/common/ads/NativoTout';
import { insertAtNodeRule } from '@/app_lib/htmlParser/inserter/rules/helpers';
import type { ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';
import type { Article } from '@/app_lib/types/Article';

interface EmbedNativoToutProps {
  isAdless?: boolean;
}

export const embedNativoTout = ({
  featuredMediaType,
  isAdless,
}: EmbedNativoToutProps & Pick<Article, 'featuredMediaType'>): ParserRule => ({
  insertComponent: () => (
    <NativoTout
      featuredMediaType={featuredMediaType}
      key={uuidv4()}
    />
  ),
  insertPosition: 'after',
  match: ({ nodeTracker, node }) =>
    !isAdless &&
    insertAtNodeRule({
      node,
      nodeTracker,
      nodeType: 'p',
      position: 13,
    }),
});
